import { TRootState } from "../@types"

export const selectModalWorkOffersCategories = ( state: TRootState ) =>state.workOffersCategories.workOffersCategoriesModalIsOpen

export const selectIsUpdateWorkOffersCategories = ( state: TRootState ) =>state.workOffersCategories.isUpdateWorkOffersCategories

export const selectWorkOffersCategoriesForUpdate = ( state: TRootState ) =>state.workOffersCategories.workOffersCategoriesForUpdate

export const selectWorkOffersCategoriesRefreshTable =  ( state: TRootState ) =>state.workOffersCategories.refreshTableWorkOffersCategories